<template>
  <div>
    <v-tabs
      slot="extension"
      v-model="selectedTab"
      centered
      color="secondary"
      slider-color="orange"
    >
      <v-tab href="#tabUsers">
        by User
      </v-tab>
      <v-tab href="#tabUserGroups">
        by User Group
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item id="tabUsers">
        <v-card text>
          <manage-users-by-user v-if="userList.length" :user-data="userList" :selected-user="selectedUser" />
        </v-card>
      </v-tab-item>
      <v-tab-item id="tabUserGroups">
        <v-card text>
          <manage-users-by-user-group v-if="userGroups.length" :user-groups="userGroups" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ManageUsersByUser from './ManageUsersByUser'
import ManageUsersByUserGroup from './ManageUsersByUserGroup'

export default {
  name: 'manage-users-tabs',
  components: {
    ManageUsersByUser,
    ManageUsersByUserGroup
  },
  props: {
    userGroups: Array,
    userList: Array,
    selectedUser: String
  },
  data() {
    return {
      selectedTab: 'tabUsers'
    }
  }
}
</script>
